import MenuTabs from '../../../components/menuTabs/index';
import UserList from '../../UserList';
import RoleList from '../../RoleList';
import './UserManager.scss';

const menuList = [
  { name: 'Users List', tags: 'users' },
  { name: 'Roles', tags: 'roles' },
];

const UserManager = ({ activeTag }) => {
  return (
    <div className="user-manager-container">
      <MenuTabs menuList={menuList} />
      <div className="user-manager-content">
        {activeTag === 'users' && <UserList />}
        {activeTag === 'roles' && <RoleList />}
      </div>
    </div>
  );
};

export default UserManager;
